import React from "react";
import { Card, Tag } from "antd";
import dayjs from "dayjs";
import translator from "@/translator";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const t = translator("note_office.views.bulk_deliveries.index_view.");

const getFormattedDate = (date, timezone = "UTC") => {
  if (!date) return "-";
  return dayjs.utc(date).tz(timezone).format("DD.MM.YYYY HH:mm");
};

const BulkDeliveryCard = ({ delivery, timezone }) => {
  const formattedDate = getFormattedDate(delivery.date, timezone);

  return (
    <Card className="bulk_deliveries__card">
      <div className="bulk_deliveries__info">
        <div className="bulk_deliveries__column">
          <span className="bulk_deliveries__label">{t("sent")}:</span>
          <span className="bulk_deliveries__value">{delivery.sent}</span>
        </div>
        <div className="bulk_deliveries__column">
          <span className="bulk_deliveries__label">{t("delivered")}:</span>
          <span className="bulk_deliveries__value">{delivery.delivered}</span>
        </div>
      </div>

      <div className="bulk_deliveries__details">
        <span className="bulk_deliveries__label">{t("status.label")}:</span>
        <Tag color={delivery.status_color}>{delivery.status}</Tag>
      </div>

      <div className="bulk_deliveries__details">
        <span className="bulk_deliveries__label">{t("date_time")}:</span>
        <span className="bulk_deliveries__text">{formattedDate}</span>
      </div>

      <div className="bulk_deliveries__details">
        <span className="bulk_deliveries__label">{t("channel")}:</span>
        <span className="bulk_deliveries__text">{delivery.channel}</span>
      </div>

      <div className="bulk_deliveries__details bulk_deliveries__details-last">
        <span className="bulk_deliveries__label">{t("text.label")}:</span>
        <span className="bulk_deliveries__text">{delivery.text}</span>
      </div>
    </Card>
  );
};

export default BulkDeliveryCard;
